/* eslint-disable */
// @ts-nocheck
import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  JSON: { input: any; output: any; }
  Upload: { input: any; output: any; }
};

export type AppointmentType =
  | 'GROOMING'
  | 'ROUTINE_CHECKUP'
  | 'SICK'
  | 'SICK_URGENT'
  | 'TECH_APPT'
  | 'VACCINE_BOOSTER';

export type AvailableSlot = {
  __typename?: 'AvailableSlot';
  date: Scalars['String']['output'];
  provider?: Maybe<AvailableSlotProvider>;
  providerId?: Maybe<Scalars['String']['output']>;
  time: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type AvailableSlotProvider = {
  __typename?: 'AvailableSlotProvider';
  username?: Maybe<Scalars['String']['output']>;
};

export type BffAdditionalInfo = {
  __typename?: 'BffAdditionalInfo';
  available_categories?: Maybe<Scalars['String']['output']>;
  available_services?: Maybe<Scalars['String']['output']>;
  can_book?: Maybe<Scalars['Boolean']['output']>;
  cancellation_fee_duration?: Maybe<Scalars['Int']['output']>;
  categories_available?: Maybe<Scalars['Boolean']['output']>;
  center_amenities?: Maybe<Scalars['String']['output']>;
  collect_feedback?: Maybe<Scalars['String']['output']>;
  cst?: Maybe<Scalars['String']['output']>;
  feedback_label?: Maybe<Scalars['String']['output']>;
  feedback_link?: Maybe<Scalars['String']['output']>;
  is_add_ons_available?: Maybe<Scalars['Boolean']['output']>;
  is_auto_pay_enabled_at_center?: Maybe<Scalars['Boolean']['output']>;
  is_center_amenities_enabled?: Maybe<Scalars['Boolean']['output']>;
  is_global_tokenization_supported?: Maybe<Scalars['Boolean']['output']>;
  service_tax_no?: Maybe<Scalars['String']['output']>;
  services_available?: Maybe<Scalars['Boolean']['output']>;
  tin?: Maybe<Scalars['String']['output']>;
  unavailable_categories?: Maybe<Scalars['String']['output']>;
  unavailable_services?: Maybe<Scalars['String']['output']>;
  vat?: Maybe<Scalars['String']['output']>;
};

export type BffAddress = {
  __typename?: 'BffAddress';
  address_1?: Maybe<Scalars['String']['output']>;
  address_2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  zip_code?: Maybe<Scalars['String']['output']>;
};

export type BffBlog = {
  __typename?: 'BffBlog';
  blogImage?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  subCategory?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  timeToRead?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type BffBrand = {
  __typename?: 'BffBrand';
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<BffBrandType>;
  name?: Maybe<Scalars['String']['output']>;
};

export type BffBrandType =
  | 'ASPEN_DENTAL'
  | 'AZ_PET'
  | 'CHAPTER'
  | 'CLEAR_CHOICE'
  | 'LOVET'
  | 'MOTTO'
  | 'WELL_NOW';

export type BffBrazeUserAttributes = {
  __typename?: 'BffBrazeUserAttributes';
  custom_attributes?: Maybe<Scalars['JSON']['output']>;
  external_id?: Maybe<Scalars['String']['output']>;
};

export type BffCacheLineStats = {
  __typename?: 'BffCacheLineStats';
  cachedAt?: Maybe<Scalars['String']['output']>;
  expires?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  secTTL?: Maybe<Scalars['Int']['output']>;
  size?: Maybe<Scalars['String']['output']>;
};

export type BffCenter = {
  __typename?: 'BffCenter';
  additional_info?: Maybe<BffAdditionalInfo>;
  address_info?: Maybe<BffAddress>;
  code?: Maybe<Scalars['String']['output']>;
  contact_info?: Maybe<BffContactInfo>;
  country?: Maybe<BffCountry>;
  culture_code_at_center?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<BffCurrency>;
  description?: Maybe<Scalars['String']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  enable_parallel_services_at_center?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  is_fbe_enabled?: Maybe<Scalars['Boolean']['output']>;
  is_hc_call_center?: Maybe<Scalars['Boolean']['output']>;
  location?: Maybe<BffLocation>;
  name?: Maybe<Scalars['String']['output']>;
  online_booking_start_date?: Maybe<Scalars['String']['output']>;
  settings?: Maybe<Scalars['String']['output']>;
  state?: Maybe<BffState>;
  working_hours?: Maybe<Array<Maybe<BffWorkinghours>>>;
};

export type BffCenters = {
  __typename?: 'BffCenters';
  centers?: Maybe<Array<Maybe<BffCenter>>>;
  error?: Maybe<Scalars['String']['output']>;
};

export type BffCertifications = {
  __typename?: 'BffCertifications';
  certification?: Maybe<Scalars['String']['output']>;
  certificationCountry?: Maybe<Scalars['String']['output']>;
  certificationName?: Maybe<Scalars['String']['output']>;
  certifierOrIssuer?: Maybe<Scalars['String']['output']>;
  issuedDate?: Maybe<Scalars['String']['output']>;
};

export type BffCity = {
  __typename?: 'BffCity';
  city?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  slugXml?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  stateAbbreviation?: Maybe<Scalars['String']['output']>;
};

export type BffClient = {
  __typename?: 'BffClient';
  addresses?: Maybe<Array<Maybe<BffClientAddress>>>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type BffClientAddress = {
  __typename?: 'BffClientAddress';
  city?: Maybe<Scalars['String']['output']>;
  isPrimary?: Maybe<Scalars['Boolean']['output']>;
  line1?: Maybe<Scalars['String']['output']>;
  line2?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type BffClientList = {
  __typename?: 'BffClientList';
  clients?: Maybe<Array<Maybe<BffClient>>>;
  errors?: Maybe<Array<Maybe<BffError>>>;
};

export type BffContactInfo = {
  __typename?: 'BffContactInfo';
  email?: Maybe<Scalars['String']['output']>;
  phone_1?: Maybe<BffPhoneNumber>;
  phone_2?: Maybe<BffPhoneNumber>;
};

export type BffCountry = {
  __typename?: 'BffCountry';
  code?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nationality?: Maybe<Scalars['String']['output']>;
  phone_code?: Maybe<Scalars['Int']['output']>;
};

export type BffCredentials = {
  __typename?: 'BffCredentials';
  collegeName?: Maybe<Scalars['String']['output']>;
  collegeState?: Maybe<Scalars['String']['output']>;
  degreeName?: Maybe<Scalars['String']['output']>;
  graduationDate?: Maybe<Scalars['String']['output']>;
};

export type BffCurrency = {
  __typename?: 'BffCurrency';
  code?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  symbol?: Maybe<Scalars['String']['output']>;
};

export type BffDamAsset = {
  __typename?: 'BffDamAsset';
  height?: Maybe<Scalars['Int']['output']>;
  mimetype?: Maybe<Scalars['String']['output']>;
  ok?: Maybe<Scalars['Boolean']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type BffError = {
  __typename?: 'BffError';
  message?: Maybe<Scalars['String']['output']>;
};

export type BffEstimate = {
  __typename?: 'BffEstimate';
  client?: Maybe<BffClient>;
  datetime?: Maybe<Scalars['String']['output']>;
  highTotal?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lowTotal?: Maybe<Scalars['Float']['output']>;
  patients?: Maybe<Array<Maybe<BffClient>>>;
  title?: Maybe<Scalars['String']['output']>;
};

/**
 * An office facility
 * Brick and Mortar part of **business** [API](http://example.com)!
 */
export type BffFacility = {
  __typename?: 'BffFacility';
  address?: Maybe<BffFacilityAddress>;
  anytimeAppointingDenture?: Maybe<Scalars['Boolean']['output']>;
  anytimeAppointingMotto?: Maybe<Scalars['Boolean']['output']>;
  attributes?: Maybe<Array<Maybe<NamedAttribute>>>;
  bilingual?: Maybe<Scalars['Boolean']['output']>;
  birdeyeBusinessId?: Maybe<Scalars['String']['output']>;
  /** Brand where the data is from */
  brand?: Maybe<Scalars['String']['output']>;
  clinicType?: Maybe<Scalars['String']['output']>;
  clockwiseId?: Maybe<Scalars['String']['output']>;
  /** Facility Code or Id */
  code: Scalars['String']['output'];
  comingSoon?: Maybe<Scalars['Boolean']['output']>;
  currentBrand?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  directions?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  dma?: Maybe<Scalars['String']['output']>;
  dnis?: Maybe<Scalars['String']['output']>;
  doctors?: Maybe<Array<Maybe<BffProvider>>>;
  email?: Maybe<Scalars['String']['output']>;
  emergencyPhoneNumber?: Maybe<Scalars['String']['output']>;
  faxNumber?: Maybe<Scalars['String']['output']>;
  firstThreeOctets?: Maybe<Scalars['String']['output']>;
  fullClinicNameWithBrand?: Maybe<Scalars['String']['output']>;
  geomodifier?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  implants?: Maybe<Scalars['String']['output']>;
  insurance?: Maybe<Array<Maybe<BffInsurance>>>;
  insuranceNetwork?: Maybe<Array<Maybe<BffInsurance>>>;
  landmarks?: Maybe<Scalars['String']['output']>;
  legalBillingName?: Maybe<Scalars['String']['output']>;
  location?: Maybe<BffFacilityLocation>;
  metroRegion?: Maybe<Scalars['String']['output']>;
  metroRegionSlug?: Maybe<Scalars['String']['output']>;
  minimumPatientAge?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  needsBasedQuestions?: Maybe<Scalars['Boolean']['output']>;
  neighboringAreas?: Maybe<Scalars['String']['output']>;
  onHVP?: Maybe<Scalars['Boolean']['output']>;
  onMotto?: Maybe<Scalars['Boolean']['output']>;
  onP3?: Maybe<Scalars['Boolean']['output']>;
  openDate?: Maybe<Scalars['String']['output']>;
  originalBrand?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  pilot1?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  reviewSummary?: Maybe<BffFacilityReviewSummary>;
  reviews?: Maybe<BffReviews>;
  revspringAccountId?: Maybe<Scalars['String']['output']>;
  revspringLocationValue?: Maybe<Scalars['String']['output']>;
  /** @deprecated Always returns null. Use salesStatusGrpc instead. */
  salesStatus?: Maybe<Scalars['String']['output']>;
  salesStatusGrpc?: Maybe<BffSalesStatus>;
  scheduleAppointmentURL?: Maybe<Scalars['String']['output']>;
  schedulingSystem?: Maybe<Scalars['String']['output']>;
  services?: Maybe<Array<Maybe<BffService>>>;
  siteGroup?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  slugXml?: Maybe<Scalars['String']['output']>;
  specialtyServices?: Maybe<Array<Maybe<BffSpecialtyService>>>;
  status?: Maybe<Scalars['String']['output']>;
  workingHours?: Maybe<Array<Maybe<BffWorkingHours>>>;
};

export type BffFacilityAddress = {
  __typename?: 'BffFacilityAddress';
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  stateCode?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type BffFacilityCollection = {
  __typename?: 'BffFacilityCollection';
  items?: Maybe<Array<Maybe<BffFacility>>>;
  returned?: Maybe<Scalars['Int']['output']>;
  skip?: Maybe<Scalars['Int']['output']>;
  take?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type BffFacilityLocation = {
  __typename?: 'BffFacilityLocation';
  directions?: Maybe<Scalars['String']['output']>;
  distance?: Maybe<Scalars['Float']['output']>;
  group?: Maybe<Scalars['String']['output']>;
  landmarks?: Maybe<Scalars['String']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  neighboringAreas?: Maybe<Scalars['String']['output']>;
  timeZone?: Maybe<Scalars['String']['output']>;
  timezoneIANA?: Maybe<Scalars['String']['output']>;
};

export type BffFacilityReviewSummary = {
  __typename?: 'BffFacilityReviewSummary';
  summaryText: Scalars['String']['output'];
  thingsToKeepInMind: Array<Scalars['String']['output']>;
  whatPatientsLike: Array<Scalars['String']['output']>;
};

export type BffFacilityScheduleType = {
  __typename?: 'BffFacilityScheduleType';
  id: Scalars['String']['output'];
  scheduleType?: Maybe<Scalars['String']['output']>;
};

export type BffFutureDays = {
  __typename?: 'BffFutureDays';
  Day?: Maybe<Scalars['String']['output']>;
  HolidayType?: Maybe<Scalars['String']['output']>;
  IsAvailable?: Maybe<Scalars['Boolean']['output']>;
};

export type BffGeocodeResult = {
  __typename?: 'BffGeocodeResult';
  formattedAddress?: Maybe<Scalars['String']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
};

export type BffInsurance = {
  __typename?: 'BffInsurance';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type BffLocation = {
  __typename?: 'BffLocation';
  latitude?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['String']['output']>;
  time_zone?: Maybe<BffTimezone>;
};

export type BffLocationAvailability = {
  __typename?: 'BffLocationAvailability';
  appointmentSlotMinutes: Scalars['Int']['output'];
  availableSlots: Array<AvailableSlot>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type BffOrder = {
  __typename?: 'BffOrder';
  client?: Maybe<BffClient>;
  datetime?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  patients?: Maybe<Array<Maybe<BffClient>>>;
  totalAfterTaxCents?: Maybe<Scalars['Float']['output']>;
};

export type BffPhoneNumber = {
  __typename?: 'BffPhoneNumber';
  country_id?: Maybe<Scalars['Int']['output']>;
  display_number?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
};

export type BffPriceInfo = {
  __typename?: 'BffPriceInfo';
  currency_id?: Maybe<Scalars['Int']['output']>;
  demand_group_id?: Maybe<Scalars['String']['output']>;
  include_tax?: Maybe<Scalars['Boolean']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  ssg?: Maybe<Scalars['Int']['output']>;
  tax_id?: Maybe<Scalars['String']['output']>;
};

export type BffProduct = {
  __typename?: 'BffProduct';
  brand: Scalars['String']['output'];
  brandfolderImageAssetUrl?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  disclaimer?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  linkText?: Maybe<Scalars['String']['output']>;
  linkUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  procedures?: Maybe<Array<Maybe<BffProductProcedure>>>;
  subCategory?: Maybe<Scalars['String']['output']>;
  totalPrice: Scalars['Float']['output'];
};

export type BffProductProcedure = {
  __typename?: 'BffProductProcedure';
  /** The price for the procedure, it can be average if not sought by facility, or specific to the facility selected. */
  price: Scalars['Float']['output'];
  procedureCode: Scalars['String']['output'];
  procedureDescription: Scalars['String']['output'];
};

export type BffProvider = {
  __typename?: 'BffProvider';
  active?: Maybe<Scalars['Boolean']['output']>;
  associations?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  biography?: Maybe<Scalars['String']['output']>;
  certifications?: Maybe<Array<Maybe<BffCertifications>>>;
  collegeCity?: Maybe<Scalars['String']['output']>;
  collegeName?: Maybe<Scalars['String']['output']>;
  collegeState?: Maybe<Scalars['String']['output']>;
  degreeName?: Maybe<Scalars['String']['output']>;
  degreeNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  educations?: Maybe<Array<Maybe<BffCredentials>>>;
  employeeId?: Maybe<Scalars['String']['output']>;
  employeeStatus?: Maybe<Scalars['String']['output']>;
  ethnicity?: Maybe<Scalars['String']['output']>;
  facilities?: Maybe<Array<Maybe<BffFacility>>>;
  firstName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  graduationDate?: Maybe<Scalars['String']['output']>;
  hireDate?: Maybe<Scalars['String']['output']>;
  jobTitle?: Maybe<Scalars['String']['output']>;
  languages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  lastName?: Maybe<Scalars['String']['output']>;
  licenses?: Maybe<Array<Maybe<BffProviderLicense>>>;
  mainWorkerFunction?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nickname?: Maybe<Scalars['String']['output']>;
  npi?: Maybe<Scalars['String']['output']>;
  photoUrl?: Maybe<Scalars['String']['output']>;
  photoUrlCollection?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  providerId?: Maybe<Scalars['String']['output']>;
  providerRole?: Maybe<BffProviderRole>;
  providerType?: Maybe<Scalars['String']['output']>;
  quote?: Maybe<Scalars['String']['output']>;
  reviewSummary?: Maybe<BffProviderReviewSummary>;
  reviews?: Maybe<Array<Maybe<BffReview>>>;
  socialNetworks?: Maybe<Array<Maybe<BffSocialNetworks>>>;
  specialties?: Maybe<Scalars['String']['output']>;
  stateLicense?: Maybe<Scalars['String']['output']>;
  volunteerism?: Maybe<Scalars['String']['output']>;
  workerType?: Maybe<Scalars['String']['output']>;
};

export type BffProviderCollection = {
  __typename?: 'BffProviderCollection';
  items?: Maybe<Array<Maybe<BffProvider>>>;
  skip?: Maybe<Scalars['Int']['output']>;
  take?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type BffProviderLicense = {
  __typename?: 'BffProviderLicense';
  state?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type BffProviderReviewSummary = {
  __typename?: 'BffProviderReviewSummary';
  averageRating?: Maybe<Scalars['Float']['output']>;
  providerId?: Maybe<Scalars['String']['output']>;
  ratings?: Maybe<Array<Maybe<BffRating>>>;
  reviewCount?: Maybe<Scalars['Int']['output']>;
};

export type BffProviderRole = {
  __typename?: 'BffProviderRole';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type BffRating = {
  __typename?: 'BffRating';
  rating?: Maybe<Scalars['Float']['output']>;
  reviewCount?: Maybe<Scalars['Int']['output']>;
};

export type BffReview = {
  __typename?: 'BffReview';
  comments?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  reviewId?: Maybe<Scalars['String']['output']>;
  reviewTimestamp?: Maybe<Scalars['String']['output']>;
  reviewer?: Maybe<BffReviewReviewer>;
  source?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  title?: Maybe<Scalars['String']['output']>;
};

export type BffReviewReviewer = {
  __typename?: 'BffReviewReviewer';
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
};

export type BffReviews = {
  __typename?: 'BffReviews';
  averageRating?: Maybe<Scalars['Float']['output']>;
  businessId?: Maybe<Scalars['String']['output']>;
  ratings?: Maybe<Array<Maybe<BffRating>>>;
  reviewCount?: Maybe<Scalars['Int']['output']>;
  reviews?: Maybe<Array<Maybe<BffReview>>>;
};

export type BffSalesStatus = {
  __typename?: 'BffSalesStatus';
  effectiveFrom?: Maybe<Scalars['String']['output']>;
  effectiveThru?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type BffService = {
  __typename?: 'BffService';
  activeFlag?: Maybe<Scalars['Boolean']['output']>;
  add_ons_info?: Maybe<Scalars['String']['output']>;
  additional_info?: Maybe<Scalars['String']['output']>;
  catalog_info?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  dentureCouponCode?: Maybe<Scalars['String']['output']>;
  dentureFee?: Maybe<Scalars['Int']['output']>;
  dentureFlag?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  finishing_services_info?: Maybe<Scalars['String']['output']>;
  formula?: Maybe<Scalars['String']['output']>;
  generalDentFee?: Maybe<Scalars['Int']['output']>;
  generalDentistryCouponCode?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  image_paths?: Maybe<Scalars['String']['output']>;
  is_couple_service?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parallel_groups?: Maybe<Scalars['String']['output']>;
  parallel_service_groups?: Maybe<Scalars['String']['output']>;
  prerequisites_info?: Maybe<Scalars['String']['output']>;
  price_info?: Maybe<BffPriceInfo>;
  procedureCategory?: Maybe<Scalars['String']['output']>;
  procedureCode?: Maybe<Scalars['String']['output']>;
  procedureDescription?: Maybe<Scalars['String']['output']>;
  promotionalPrice?: Maybe<Scalars['Int']['output']>;
  recovery_time?: Maybe<Scalars['Int']['output']>;
  variants_info?: Maybe<Scalars['String']['output']>;
};

export type BffServices = {
  __typename?: 'BffServices';
  error?: Maybe<Scalars['String']['output']>;
  services?: Maybe<Array<Maybe<BffService>>>;
};

export type BffSession = {
  __typename?: 'BffSession';
  Error?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
};

export type BffSlot = {
  __typename?: 'BffSlot';
  Available?: Maybe<Scalars['Boolean']['output']>;
  Priority?: Maybe<Scalars['Int']['output']>;
  SalePrice?: Maybe<Scalars['String']['output']>;
  Time?: Maybe<Scalars['String']['output']>;
  Warnings?: Maybe<Scalars['String']['output']>;
};

export type BffSlots = {
  __typename?: 'BffSlots';
  Error?: Maybe<Scalars['String']['output']>;
  future_days?: Maybe<Array<Maybe<BffFutureDays>>>;
  next_available_day?: Maybe<Scalars['String']['output']>;
  slots?: Maybe<Array<Maybe<BffSlot>>>;
};

export type BffSocialNetworks = {
  __typename?: 'BffSocialNetworks';
  type?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type BffSpecialtyService = {
  __typename?: 'BffSpecialtyService';
  name?: Maybe<Scalars['String']['output']>;
};

export type BffState = {
  __typename?: 'BffState';
  abbreviation?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  short_name?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  slugXml?: Maybe<Scalars['String']['output']>;
};

export type BffTimeSpan = {
  __typename?: 'BffTimeSpan';
  /** The LocalTime scalar type is a local time string (i.e., with no associated timezone) in 24-hr HH:mm:ss. */
  from?: Maybe<Scalars['String']['output']>;
  to?: Maybe<Scalars['String']['output']>;
};

export type BffTimezone = {
  __typename?: 'BffTimezone';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  standard_name?: Maybe<Scalars['String']['output']>;
  symbol?: Maybe<Scalars['String']['output']>;
};

export type BffUsCity = {
  __typename?: 'BffUSCity';
  centers?: Maybe<Array<Maybe<BffFacility>>>;
  city?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  slugXml?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  stateAbbreviation?: Maybe<Scalars['String']['output']>;
};

export type BffWorkingHours = {
  __typename?: 'BffWorkingHours';
  date?: Maybe<Scalars['String']['output']>;
  open?: Maybe<BffTimeSpan>;
};

export type BffWorkinghours = {
  __typename?: 'BffWorkinghours';
  day_of_week?: Maybe<Scalars['String']['output']>;
  end_time?: Maybe<Scalars['String']['output']>;
  is_closed?: Maybe<Scalars['Boolean']['output']>;
  off_peak_end_time?: Maybe<Scalars['String']['output']>;
  off_peak_start_time?: Maybe<Scalars['String']['output']>;
  offline_end_time?: Maybe<Scalars['String']['output']>;
  offline_start_time?: Maybe<Scalars['String']['output']>;
  start_time?: Maybe<Scalars['String']['output']>;
};

export type BrandfolderCustomField = {
  __typename?: 'BrandfolderCustomField';
  name?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type BrandfolderDamVideoAsset = {
  __typename?: 'BrandfolderDamVideoAsset';
  customFields: Array<BrandfolderCustomField>;
  height?: Maybe<Scalars['Int']['output']>;
  imageOrder?: Maybe<Scalars['Int']['output']>;
  mimetype?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  streamingUrl?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type CacheControlScope =
  | 'PRIVATE'
  | 'PUBLIC';

export type ConsentResponse = {
  __typename?: 'ConsentResponse';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  consentManagement?: Maybe<ConsentResponse>;
  uploadPatientDocument: PatientDocument;
  uploadPatientImage: Patient;
};


export type MutationConsentManagementArgs = {
  brand: BffBrandType;
  payload: Scalars['JSON']['input'];
};


export type MutationUploadPatientDocumentArgs = {
  brand: BffBrandType;
  category?: InputMaybe<Scalars['String']['input']>;
  encounterId?: InputMaybe<Scalars['ID']['input']>;
  encounterSectionName?: InputMaybe<Scalars['String']['input']>;
  file: Scalars['Upload']['input'];
  name: Scalars['String']['input'];
  patientId: Scalars['String']['input'];
};


export type MutationUploadPatientImageArgs = {
  brand: BffBrandType;
  file: Scalars['Upload']['input'];
  patientId: Scalars['String']['input'];
};

export type NamedAttribute = {
  __typename?: 'NamedAttribute';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type OneTrustConsentContent = {
  __typename?: 'OneTrustConsentContent';
  CreatedDate?: Maybe<Scalars['String']['output']>;
  DataElements?: Maybe<Array<Maybe<OneTrustDataElement>>>;
  Id?: Maybe<Scalars['String']['output']>;
  Identifier?: Maybe<Scalars['String']['output']>;
  Language?: Maybe<Scalars['String']['output']>;
  LastUpdatedDate?: Maybe<Scalars['String']['output']>;
  Purposes?: Maybe<Array<Maybe<OneTrustPurpose>>>;
  TestDataSubject?: Maybe<Scalars['Boolean']['output']>;
};

export type OneTrustConsentPreferences = {
  __typename?: 'OneTrustConsentPreferences';
  content?: Maybe<Array<Maybe<OneTrustConsentContent>>>;
  empty?: Maybe<Scalars['Boolean']['output']>;
  first?: Maybe<Scalars['Boolean']['output']>;
  last?: Maybe<Scalars['Boolean']['output']>;
  number?: Maybe<Scalars['Int']['output']>;
  numberOfElements?: Maybe<Scalars['Int']['output']>;
  pageable?: Maybe<OneTrustPageable>;
  size?: Maybe<Scalars['Int']['output']>;
  sort?: Maybe<OneTrustSort>;
  totalElements?: Maybe<Scalars['Int']['output']>;
  totalPages?: Maybe<Scalars['Int']['output']>;
};

export type OneTrustDataElement = {
  __typename?: 'OneTrustDataElement';
  Linked?: Maybe<Scalars['Boolean']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  Value?: Maybe<Scalars['String']['output']>;
};

export type OneTrustPageable = {
  __typename?: 'OneTrustPageable';
  offset?: Maybe<Scalars['Int']['output']>;
  pageNumber?: Maybe<Scalars['Int']['output']>;
  pageSize?: Maybe<Scalars['Int']['output']>;
  paged?: Maybe<Scalars['Boolean']['output']>;
  requestContinuation?: Maybe<Scalars['String']['output']>;
  sort?: Maybe<OneTrustSort>;
  unpaged?: Maybe<Scalars['Boolean']['output']>;
};

export type OneTrustPurpose = {
  __typename?: 'OneTrustPurpose';
  ConsentDate?: Maybe<Scalars['String']['output']>;
  CustomPreferences?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  ExpiryDate?: Maybe<Scalars['String']['output']>;
  FirstTransactionDate?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['String']['output']>;
  LastInteractionDate?: Maybe<Scalars['String']['output']>;
  LastReceiptId?: Maybe<Scalars['String']['output']>;
  LastTransactionCollectionPointId?: Maybe<Scalars['String']['output']>;
  LastTransactionCollectionPointVersion?: Maybe<Scalars['Int']['output']>;
  LastTransactionDate?: Maybe<Scalars['String']['output']>;
  LastUpdatedDate?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  PurposeNote?: Maybe<Scalars['String']['output']>;
  ReactivationDate?: Maybe<Scalars['String']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  Topics?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  TotalTransactionCount?: Maybe<Scalars['Int']['output']>;
  Version?: Maybe<Scalars['Int']['output']>;
  WithdrawalDate?: Maybe<Scalars['String']['output']>;
  attributes?: Maybe<Scalars['JSON']['output']>;
};

export type OneTrustSort = {
  __typename?: 'OneTrustSort';
  empty?: Maybe<Scalars['Boolean']['output']>;
  sorted?: Maybe<Scalars['Boolean']['output']>;
  unsorted?: Maybe<Scalars['Boolean']['output']>;
};

export type Patient = {
  __typename?: 'Patient';
  id: Scalars['String']['output'];
  profileImageUrl: Scalars['String']['output'];
};

export type PatientDocument = {
  __typename?: 'PatientDocument';
  category?: Maybe<Scalars['String']['output']>;
  datetime?: Maybe<Scalars['String']['output']>;
  encounterSectionName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  path?: Maybe<Scalars['String']['output']>;
};

export type Query = {
  __typename?: 'Query';
  allProviders?: Maybe<Array<Maybe<BffProvider>>>;
  availabilityByLocation?: Maybe<BffLocationAvailability>;
  blogs?: Maybe<Array<Maybe<BffBlog>>>;
  brazeUserAttributes?: Maybe<BffBrazeUserAttributes>;
  client?: Maybe<BffClientList>;
  consentPreferences?: Maybe<OneTrustConsentPreferences>;
  createBooking?: Maybe<BffSession>;
  delegateQuery?: Maybe<Scalars['JSON']['output']>;
  delegateQueryVar?: Maybe<Scalars['JSON']['output']>;
  estimatesByClientId?: Maybe<Array<Maybe<BffEstimate>>>;
  facilitiesByAddress?: Maybe<Array<Maybe<BffFacility>>>;
  facilitiesBySearch?: Maybe<Array<Maybe<BffFacility>>>;
  facilitiesByState?: Maybe<Array<Maybe<BffFacility>>>;
  facilitiesByStateAndCity?: Maybe<Array<Maybe<BffFacility>>>;
  facilitiesByStateCityAndStreet?: Maybe<Array<Maybe<BffFacility>>>;
  facilitiesByStateCityAndZipcode?: Maybe<Array<Maybe<BffFacility>>>;
  facilitiesByZipcode?: Maybe<Array<Maybe<BffFacility>>>;
  facilitiesScheduleType?: Maybe<Array<Maybe<BffFacilityScheduleType>>>;
  facilitiesViaGrpc?: Maybe<BffFacilityCollection>;
  facilityBrand?: Maybe<Array<Maybe<BffBrand>>>;
  facilityById?: Maybe<BffFacility>;
  facilityByLocation?: Maybe<Array<Maybe<BffFacility>>>;
  facilityCities?: Maybe<Array<Maybe<BffUsCity>>>;
  facilityCitiesByState?: Maybe<Array<Maybe<BffCity>>>;
  facilityCollection?: Maybe<BffFacilityCollection>;
  facilityMediaById?: Maybe<Array<Maybe<BrandfolderDamVideoAsset>>>;
  facilityPicById?: Maybe<Array<Maybe<BffDamAsset>>>;
  facilityStates?: Maybe<Array<Maybe<BffState>>>;
  geocode?: Maybe<BffGeocodeResult>;
  getCenters?: Maybe<BffCenters>;
  getServices?: Maybe<BffServices>;
  getSlots?: Maybe<BffSlots>;
  ordersByClientId?: Maybe<Array<Maybe<BffOrder>>>;
  productsWithIds?: Maybe<Array<Maybe<BffProduct>>>;
  providerById?: Maybe<BffProvider>;
  providerCollection?: Maybe<BffProviderCollection>;
  providerPicById?: Maybe<Array<Maybe<BffDamAsset>>>;
  providerPicByNpi?: Maybe<Array<Maybe<BffDamAsset>>>;
  providersByIdList?: Maybe<Array<Maybe<BffProvider>>>;
  reviewByFacility?: Maybe<BffReviews>;
  reviewSummaryByProvider?: Maybe<BffProviderReviewSummary>;
  reviews?: Maybe<BffReviews>;
  reviewsByProvider?: Maybe<Array<Maybe<BffReview>>>;
  reviewsSelection?: Maybe<Array<Maybe<BffReview>>>;
  states?: Maybe<Array<Maybe<BffState>>>;
  statesByAbbreviation?: Maybe<BffState>;
  statesByName?: Maybe<BffState>;
  workHours?: Maybe<Array<Maybe<BffWorkingHours>>>;
};


export type QueryAllProvidersArgs = {
  brand: BffBrandType;
};


export type QueryAvailabilityByLocationArgs = {
  appointmentTypes: Array<InputMaybe<AppointmentType>>;
  brand: BffBrandType;
  dateFrom: Scalars['String']['input'];
  dateTo: Scalars['String']['input'];
  facilityId: Scalars['String']['input'];
};


export type QueryBlogsArgs = {
  brand: BffBrandType;
  facilityCode: Scalars['String']['input'];
};


export type QueryBrazeUserAttributesArgs = {
  brand: BffBrandType;
  id: Scalars['String']['input'];
};


export type QueryClientArgs = {
  brand: BffBrandType;
  phoneNumber: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type QueryConsentPreferencesArgs = {
  brand: BffBrandType;
  identifier: Scalars['String']['input'];
};


export type QueryCreateBookingArgs = {
  brand: BffBrandType;
  centerId: Scalars['String']['input'];
  date: Scalars['String']['input'];
  isDoubleBookingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isOnlyCatalogEmployees?: InputMaybe<Scalars['Boolean']['input']>;
  serviceId: Scalars['String']['input'];
};


export type QueryDelegateQueryArgs = {
  brand: BffBrandType;
  query: Scalars['String']['input'];
};


export type QueryDelegateQueryVarArgs = {
  brand: BffBrandType;
  operationName: Scalars['String']['input'];
  query: Scalars['String']['input'];
  variables?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryEstimatesByClientIdArgs = {
  brand: BffBrandType;
  clientId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFacilitiesByAddressArgs = {
  address: Scalars['String']['input'];
  brand: BffBrandType;
  defaultLatitude?: InputMaybe<Scalars['Float']['input']>;
  defaultLongitude?: InputMaybe<Scalars['Float']['input']>;
  fetchAllIfNoResults?: InputMaybe<Scalars['Boolean']['input']>;
  maxItems?: InputMaybe<Scalars['Int']['input']>;
  radiusMiles?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFacilitiesBySearchArgs = {
  address: Scalars['String']['input'];
  brand: BffBrandType;
  defaultLatitude?: InputMaybe<Scalars['Float']['input']>;
  defaultLongitude?: InputMaybe<Scalars['Float']['input']>;
  fetchAllIfNoResults?: InputMaybe<Scalars['Boolean']['input']>;
  maxItems?: InputMaybe<Scalars['Int']['input']>;
  radiusMiles?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFacilitiesByStateArgs = {
  brand: BffBrandType;
  state: Scalars['String']['input'];
};


export type QueryFacilitiesByStateAndCityArgs = {
  brand: BffBrandType;
  city: Scalars['String']['input'];
  state: Scalars['String']['input'];
};


export type QueryFacilitiesByStateCityAndStreetArgs = {
  brand: BffBrandType;
  city: Scalars['String']['input'];
  state: Scalars['String']['input'];
  street: Scalars['String']['input'];
};


export type QueryFacilitiesByStateCityAndZipcodeArgs = {
  brand: BffBrandType;
  city: Scalars['String']['input'];
  state: Scalars['String']['input'];
  zipCode: Scalars['String']['input'];
};


export type QueryFacilitiesByZipcodeArgs = {
  brand: BffBrandType;
  defaultLatitude?: InputMaybe<Scalars['Float']['input']>;
  defaultLongitude?: InputMaybe<Scalars['Float']['input']>;
  fetchAllIfNoResults?: InputMaybe<Scalars['Boolean']['input']>;
  maxItems?: InputMaybe<Scalars['Int']['input']>;
  radiusMiles?: InputMaybe<Scalars['Int']['input']>;
  zipCode: Scalars['String']['input'];
};


export type QueryFacilitiesScheduleTypeArgs = {
  brand: BffBrandType;
};


export type QueryFacilitiesViaGrpcArgs = {
  brand: BffBrandType;
  skip?: InputMaybe<Scalars['Int']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFacilityByIdArgs = {
  brand: BffBrandType;
  id: Scalars['String']['input'];
};


export type QueryFacilityByLocationArgs = {
  brand: BffBrandType;
  defaultLatitude?: InputMaybe<Scalars['Float']['input']>;
  defaultLongitude?: InputMaybe<Scalars['Float']['input']>;
  fetchAllIfNoResults?: InputMaybe<Scalars['Boolean']['input']>;
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  maxItems?: InputMaybe<Scalars['Int']['input']>;
  radiusMiles?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFacilityCitiesArgs = {
  brand: BffBrandType;
};


export type QueryFacilityCitiesByStateArgs = {
  brand: BffBrandType;
  state: Scalars['String']['input'];
};


export type QueryFacilityCollectionArgs = {
  brand: BffBrandType;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFacilityMediaByIdArgs = {
  brand: BffBrandType;
  code: Scalars['String']['input'];
};


export type QueryFacilityPicByIdArgs = {
  brand: BffBrandType;
  id: Scalars['String']['input'];
};


export type QueryFacilityStatesArgs = {
  brand: BffBrandType;
};


export type QueryGeocodeArgs = {
  address: Scalars['String']['input'];
  brand: BffBrandType;
};


export type QueryGetCentersArgs = {
  brand: BffBrandType;
  catalogEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetServicesArgs = {
  brand: BffBrandType;
  catalogEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  centerId: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetSlotsArgs = {
  bookingId: Scalars['String']['input'];
  brand: BffBrandType;
  checkFutureDayAvailablity?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryOrdersByClientIdArgs = {
  brand: BffBrandType;
  clientId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
};


export type QueryProductsWithIdsArgs = {
  brand: BffBrandType;
  facilityCode: Scalars['String']['input'];
  idList: Array<InputMaybe<Scalars['String']['input']>>;
};


export type QueryProviderByIdArgs = {
  brand: BffBrandType;
  id: Scalars['String']['input'];
};


export type QueryProviderCollectionArgs = {
  brand: BffBrandType;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryProviderPicByIdArgs = {
  brand: BffBrandType;
  id: Scalars['String']['input'];
};


export type QueryProviderPicByNpiArgs = {
  brand: BffBrandType;
  npi: Scalars['String']['input'];
};


export type QueryProvidersByIdListArgs = {
  brand: BffBrandType;
  idList: Array<InputMaybe<Scalars['String']['input']>>;
};


export type QueryReviewByFacilityArgs = {
  brand: BffBrandType;
  facilityCode: Scalars['String']['input'];
};


export type QueryReviewSummaryByProviderArgs = {
  brand: BffBrandType;
  npi: Scalars['String']['input'];
};


export type QueryReviewsArgs = {
  brand: BffBrandType;
  facilityCode: Scalars['String']['input'];
};


export type QueryReviewsByProviderArgs = {
  brand: BffBrandType;
  npi: Scalars['String']['input'];
};


export type QueryReviewsSelectionArgs = {
  brand: BffBrandType;
  facilityCode: Scalars['String']['input'];
  max?: InputMaybe<Scalars['Int']['input']>;
  min?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryStatesByAbbreviationArgs = {
  abbreviation: Scalars['String']['input'];
};


export type QueryStatesByNameArgs = {
  name: Scalars['String']['input'];
};


export type QueryWorkHoursArgs = {
  brand: BffBrandType;
  facilityId: Scalars['String']['input'];
};

export type Token = {
  __typename?: 'Token';
  access_token?: Maybe<Scalars['String']['output']>;
};

export type BffFacilityAddressFragment = { __typename?: 'BffFacilityAddress', address1?: string | null, address2?: string | null, city?: string | null, stateCode?: string | null, zipCode?: string | null };

export type BffFacilityLocationFragment = { __typename?: 'BffFacilityLocation', distance?: number | null, landmarks?: string | null, directions?: string | null, latitude?: number | null, longitude?: number | null, neighboringAreas?: string | null, timeZone?: string | null };

export type BffTimeSpanFragment = { __typename?: 'BffTimeSpan', from?: string | null, to?: string | null };

export type BffWorkingHoursFragment = { __typename?: 'BffWorkingHours', date?: string | null, open?: (
    { __typename?: 'BffTimeSpan' }
    & BffTimeSpanFragment
  ) | null };

export type BffNamedAttributeFragment = { __typename?: 'NamedAttribute', name?: string | null, value?: string | null };

export type BffReviewsFragment = { __typename?: 'BffReviews', averageRating?: number | null, businessId?: string | null, reviewCount?: number | null };

export type BffFacilityFieldsFragment = { __typename?: 'BffFacility', name?: string | null, displayName?: string | null, legalBillingName?: string | null, region?: string | null, code: string, brand?: string | null, phoneNumber?: string | null, faxNumber?: string | null, email?: string | null, scheduleAppointmentURL?: string | null, schedulingSystem?: string | null, revspringAccountId?: string | null, revspringLocationValue?: string | null, bilingual?: boolean | null, landmarks?: string | null, neighboringAreas?: string | null, directions?: string | null, originalBrand?: string | null, address?: (
    { __typename?: 'BffFacilityAddress' }
    & BffFacilityAddressFragment
  ) | null, location?: (
    { __typename?: 'BffFacilityLocation' }
    & BffFacilityLocationFragment
  ) | null, workingHours?: Array<(
    { __typename?: 'BffWorkingHours' }
    & BffWorkingHoursFragment
  ) | null> | null, doctors?: Array<(
    { __typename?: 'BffProvider' }
    & BffProviderFieldsFragment
  ) | null> | null, attributes?: Array<(
    { __typename?: 'NamedAttribute' }
    & BffNamedAttributeFragment
  ) | null> | null, reviews?: (
    { __typename?: 'BffReviews' }
    & BffReviewsFragment
  ) | null, specialtyServices?: Array<{ __typename?: 'BffSpecialtyService', name?: string | null } | null> | null };

export type BffProviderFieldsFragment = { __typename?: 'BffProvider', firstName?: string | null, lastName?: string | null, jobTitle?: string | null, degreeName?: string | null, collegeName?: string | null, npi?: string | null, biography?: string | null, photoUrl?: string | null, name?: string | null };

export type ConsentManagementMutationVariables = Exact<{
  brand: BffBrandType;
  payload: Scalars['JSON']['input'];
}>;


export type ConsentManagementMutation = { __typename?: 'Mutation', consentManagement?: { __typename?: 'ConsentResponse', message?: string | null, success: boolean } | null };

export type BffAvailabilityByLocationQueryVariables = Exact<{
  brand: BffBrandType;
  facilityId: Scalars['String']['input'];
  dateFrom: Scalars['String']['input'];
  dateTo: Scalars['String']['input'];
}>;


export type BffAvailabilityByLocationQuery = { __typename?: 'Query', availabilityByLocation?: { __typename?: 'BffLocationAvailability', appointmentSlotMinutes: number, name: string, availableSlots: Array<{ __typename?: 'AvailableSlot', date: string, time: string, type: string }> } | null };

export type BffFacilitiesQueryVariables = Exact<{
  brand: BffBrandType;
  take: Scalars['Int']['input'];
  skip: Scalars['Int']['input'];
}>;


export type BffFacilitiesQuery = { __typename?: 'Query', facilityCollection?: { __typename?: 'BffFacilityCollection', skip?: number | null, take?: number | null, total?: number | null, items?: Array<(
      { __typename?: 'BffFacility' }
      & BffFacilityFieldsFragment
    ) | null> | null } | null };

export type BffFacilitiesByAddressQueryVariables = Exact<{
  brand: BffBrandType;
  address: Scalars['String']['input'];
  fetchAllIfNoResults?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type BffFacilitiesByAddressQuery = { __typename?: 'Query', facilitiesByAddress?: Array<(
    { __typename?: 'BffFacility' }
    & BffFacilityFieldsFragment
  ) | null> | null };

export type BffFacilitiesBySearchQueryVariables = Exact<{
  brand: BffBrandType;
  address: Scalars['String']['input'];
  fetchAllIfNoResults?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type BffFacilitiesBySearchQuery = { __typename?: 'Query', facilitiesBySearch?: Array<(
    { __typename?: 'BffFacility' }
    & BffFacilityFieldsFragment
  ) | null> | null };

export type BffFacilitiesByStateQueryVariables = Exact<{
  brand: BffBrandType;
  state: Scalars['String']['input'];
}>;


export type BffFacilitiesByStateQuery = { __typename?: 'Query', facilitiesByState?: Array<(
    { __typename?: 'BffFacility' }
    & BffFacilityFieldsFragment
  ) | null> | null };

export type BffFacilitiesByStateAndCityQueryVariables = Exact<{
  brand: BffBrandType;
  state: Scalars['String']['input'];
  city: Scalars['String']['input'];
}>;


export type BffFacilitiesByStateAndCityQuery = { __typename?: 'Query', facilitiesByStateAndCity?: Array<(
    { __typename?: 'BffFacility' }
    & BffFacilityFieldsFragment
  ) | null> | null };

export type BffFacilitiesByStateCityAndStreetQueryVariables = Exact<{
  brand: BffBrandType;
  state: Scalars['String']['input'];
  city: Scalars['String']['input'];
  street: Scalars['String']['input'];
}>;


export type BffFacilitiesByStateCityAndStreetQuery = { __typename?: 'Query', facilitiesByStateCityAndStreet?: Array<(
    { __typename?: 'BffFacility' }
    & BffFacilityFieldsFragment
  ) | null> | null };

export type BffFacilitiesByZipcodeQueryVariables = Exact<{
  brand: BffBrandType;
  zipCode: Scalars['String']['input'];
  radiusMiles?: InputMaybe<Scalars['Int']['input']>;
  maxItems?: InputMaybe<Scalars['Int']['input']>;
  fetchAllIfNoResults?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type BffFacilitiesByZipcodeQuery = { __typename?: 'Query', facilitiesByZipcode?: Array<(
    { __typename?: 'BffFacility' }
    & BffFacilityFieldsFragment
  ) | null> | null };

export type BffFacilityByIdQueryVariables = Exact<{
  brand: BffBrandType;
  id: Scalars['String']['input'];
}>;


export type BffFacilityByIdQuery = { __typename?: 'Query', facilityById?: (
    { __typename?: 'BffFacility' }
    & BffFacilityFieldsFragment
  ) | null };

export type BffFacilityCitiesQueryVariables = Exact<{
  brand: BffBrandType;
}>;


export type BffFacilityCitiesQuery = { __typename?: 'Query', facilityCities?: Array<{ __typename?: 'BffUSCity', city?: string | null, state?: string | null, stateAbbreviation?: string | null, slugXml?: string | null, centers?: Array<{ __typename?: 'BffFacility', id?: string | null, name?: string | null, address?: { __typename?: 'BffFacilityAddress', address1?: string | null, zipCode?: string | null } | null } | null> | null } | null> | null };

export type BffFacilityCitiesByStateQueryVariables = Exact<{
  brand: BffBrandType;
  state: Scalars['String']['input'];
}>;


export type BffFacilityCitiesByStateQuery = { __typename?: 'Query', facilityCitiesByState?: Array<{ __typename?: 'BffCity', city?: string | null, state?: string | null, stateAbbreviation?: string | null } | null> | null };

export type FacilityCollectionQueryVariables = Exact<{
  brand: BffBrandType;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
}>;


export type FacilityCollectionQuery = { __typename?: 'Query', facilityCollection?: { __typename?: 'BffFacilityCollection', total?: number | null, skip?: number | null, take?: number | null, items?: Array<{ __typename?: 'BffFacility', code: string, slugXml?: string | null } | null> | null } | null };

export type BffFacilityStatesQueryVariables = Exact<{
  brand: BffBrandType;
}>;


export type BffFacilityStatesQuery = { __typename?: 'Query', facilityStates?: Array<{ __typename?: 'BffState', abbreviation?: string | null, name?: string | null, slugXml?: string | null } | null> | null };

export type BffNearByFacilitiesByLocationQueryVariables = Exact<{
  brand: BffBrandType;
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  fetchAllIfNoResults?: InputMaybe<Scalars['Boolean']['input']>;
  radiusMiles?: InputMaybe<Scalars['Int']['input']>;
  maxItems?: InputMaybe<Scalars['Int']['input']>;
}>;


export type BffNearByFacilitiesByLocationQuery = { __typename?: 'Query', facilityByLocation?: Array<(
    { __typename?: 'BffFacility' }
    & BffFacilityFieldsFragment
  ) | null> | null };

export type BffProductsWithIdsQueryVariables = Exact<{
  brand: BffBrandType;
  idList: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
  facilityCode: Scalars['String']['input'];
}>;


export type BffProductsWithIdsQuery = { __typename?: 'Query', productsWithIds?: Array<{ __typename?: 'BffProduct', brand: string, brandfolderImageAssetUrl?: string | null, category?: string | null, subCategory?: string | null, description?: string | null, id: string, name: string, linkText?: string | null, linkUrl?: string | null, totalPrice: number, procedures?: Array<{ __typename?: 'BffProductProcedure', price: number, procedureCode: string, procedureDescription: string } | null> | null } | null> | null };

export type BffReviewsQueryVariables = Exact<{
  brand: BffBrandType;
  facilityCode: Scalars['String']['input'];
}>;


export type BffReviewsQuery = { __typename?: 'Query', reviews?: { __typename?: 'BffReviews', averageRating?: number | null, businessId?: string | null, reviewCount?: number | null, ratings?: Array<{ __typename?: 'BffRating', rating?: number | null, reviewCount?: number | null } | null> | null, reviews?: Array<{ __typename?: 'BffReview', comments?: string | null, rating?: number | null, reviewId?: string | null, reviewTimestamp?: string | null, source?: string | null, reviewer?: { __typename?: 'BffReviewReviewer', firstName?: string | null, lastName?: string | null } | null } | null> | null } | null };

export type BffReviewsSelectionQueryVariables = Exact<{
  brand: BffBrandType;
  facilityCode: Scalars['String']['input'];
  min?: InputMaybe<Scalars['Int']['input']>;
  max?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
}>;


export type BffReviewsSelectionQuery = { __typename?: 'Query', reviewsSelection?: Array<{ __typename?: 'BffReview', comments?: string | null, rating?: number | null, reviewId?: string | null, reviewTimestamp?: string | null, source?: string | null, tags?: Array<string | null> | null, title?: string | null, reviewer?: { __typename?: 'BffReviewReviewer', firstName?: string | null, lastName?: string | null } | null } | null> | null };

export type FacilityByIdQueryVariables = Exact<{
  brand: BffBrandType;
  facilityByIdId: Scalars['String']['input'];
}>;


export type FacilityByIdQuery = { __typename?: 'Query', facilityById?: { __typename?: 'BffFacility', doctors?: Array<{ __typename?: 'BffProvider', firstName?: string | null, lastName?: string | null, quote?: string | null } | null> | null } | null };

export type GetSelectedReviewsIdQueryVariables = Exact<{
  code: Scalars['String']['input'];
  brand: BffBrandType;
  min?: InputMaybe<Scalars['Int']['input']>;
  max?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetSelectedReviewsIdQuery = { __typename?: 'Query', reviewsSelection?: Array<{ __typename?: 'BffReview', reviewId?: string | null } | null> | null };

export type ProviderPicByNpiQueryVariables = Exact<{
  brand: BffBrandType;
  npi: Scalars['String']['input'];
}>;


export type ProviderPicByNpiQuery = { __typename?: 'Query', providerPicByNpi?: Array<{ __typename?: 'BffDamAsset', url?: string | null } | null> | null };

export type ProvidersByIdListQueryVariables = Exact<{
  brand: BffBrandType;
  idList: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
}>;


export type ProvidersByIdListQuery = { __typename?: 'Query', providersByIdList?: Array<(
    { __typename?: 'BffProvider' }
    & BffProviderFieldsFragment
  ) | null> | null };

export type ReviewSummaryByProviderQueryVariables = Exact<{
  brand: BffBrandType;
  npi: Scalars['String']['input'];
}>;


export type ReviewSummaryByProviderQuery = { __typename?: 'Query', reviewSummaryByProvider?: { __typename?: 'BffProviderReviewSummary', providerId?: string | null, averageRating?: number | null, reviewCount?: number | null, ratings?: Array<{ __typename?: 'BffRating', rating?: number | null, reviewCount?: number | null } | null> | null } | null };

export type ReviewsByProviderQueryVariables = Exact<{
  brand: BffBrandType;
  npi: Scalars['String']['input'];
}>;


export type ReviewsByProviderQuery = { __typename?: 'Query', reviewsByProvider?: Array<{ __typename?: 'BffReview', comments?: string | null, rating?: number | null, reviewId?: string | null, reviewTimestamp?: string | null, source?: string | null, reviewer?: { __typename?: 'BffReviewReviewer', firstName?: string | null, lastName?: string | null } | null } | null> | null };

export const BffFacilityAddressFragmentDoc = gql`
    fragment BffFacilityAddress on BffFacilityAddress {
  address1
  address2
  city
  stateCode
  zipCode
}
    `;
export const BffFacilityLocationFragmentDoc = gql`
    fragment BffFacilityLocation on BffFacilityLocation {
  distance
  landmarks
  directions
  latitude
  longitude
  neighboringAreas
  timeZone
}
    `;
export const BffTimeSpanFragmentDoc = gql`
    fragment BffTimeSpan on BffTimeSpan {
  from
  to
}
    `;
export const BffWorkingHoursFragmentDoc = gql`
    fragment BffWorkingHours on BffWorkingHours {
  date
  open {
    ...BffTimeSpan
  }
}
    `;
export const BffProviderFieldsFragmentDoc = gql`
    fragment BffProviderFields on BffProvider {
  firstName
  lastName
  jobTitle
  degreeName
  collegeName
  npi
  biography
  photoUrl
  name
}
    `;
export const BffNamedAttributeFragmentDoc = gql`
    fragment BFFNamedAttribute on NamedAttribute {
  name
  value
}
    `;
export const BffReviewsFragmentDoc = gql`
    fragment BFFReviews on BffReviews {
  averageRating
  businessId
  reviewCount
}
    `;
export const BffFacilityFieldsFragmentDoc = gql`
    fragment BffFacilityFields on BffFacility {
  name
  displayName
  legalBillingName
  region
  code
  brand
  phoneNumber
  faxNumber
  email
  scheduleAppointmentURL
  schedulingSystem
  revspringAccountId
  revspringLocationValue
  address {
    ...BffFacilityAddress
  }
  location {
    ...BffFacilityLocation
  }
  workingHours {
    ...BffWorkingHours
  }
  doctors {
    ...BffProviderFields
  }
  attributes {
    ...BFFNamedAttribute
  }
  reviews {
    ...BFFReviews
  }
  specialtyServices {
    name
  }
  bilingual
  landmarks
  neighboringAreas
  directions
  originalBrand
}
    `;
export const ConsentManagementDocument = gql`
    mutation ConsentManagement($brand: BffBrandType!, $payload: JSON!) {
  consentManagement(brand: $brand, payload: $payload) {
    message
    success
  }
}
    `;

export function useConsentManagementMutation() {
  return Urql.useMutation<ConsentManagementMutation, ConsentManagementMutationVariables>(ConsentManagementDocument);
};
export const BffAvailabilityByLocationDocument = gql`
    query bffAvailabilityByLocation($brand: BffBrandType!, $facilityId: String!, $dateFrom: String!, $dateTo: String!) {
  availabilityByLocation(
    brand: $brand
    facilityId: $facilityId
    appointmentTypes: [ROUTINE_CHECKUP, SICK_URGENT]
    dateFrom: $dateFrom
    dateTo: $dateTo
  ) {
    appointmentSlotMinutes
    name
    availableSlots {
      date
      time
      type
    }
  }
}
    `;

export function useBffAvailabilityByLocationQuery(options: Omit<Urql.UseQueryArgs<BffAvailabilityByLocationQueryVariables>, 'query'>) {
  return Urql.useQuery<BffAvailabilityByLocationQuery, BffAvailabilityByLocationQueryVariables>({ query: BffAvailabilityByLocationDocument, ...options });
};
export const BffFacilitiesDocument = gql`
    query bffFacilities($brand: BffBrandType!, $take: Int!, $skip: Int!) {
  facilityCollection(brand: $brand, take: $take, skip: $skip) {
    items {
      ...BffFacilityFields
    }
    skip
    take
    total
  }
}
    ${BffFacilityFieldsFragmentDoc}
${BffFacilityAddressFragmentDoc}
${BffFacilityLocationFragmentDoc}
${BffWorkingHoursFragmentDoc}
${BffTimeSpanFragmentDoc}
${BffProviderFieldsFragmentDoc}
${BffNamedAttributeFragmentDoc}
${BffReviewsFragmentDoc}`;

export function useBffFacilitiesQuery(options: Omit<Urql.UseQueryArgs<BffFacilitiesQueryVariables>, 'query'>) {
  return Urql.useQuery<BffFacilitiesQuery, BffFacilitiesQueryVariables>({ query: BffFacilitiesDocument, ...options });
};
export const BffFacilitiesByAddressDocument = gql`
    query bffFacilitiesByAddress($brand: BffBrandType!, $address: String!, $fetchAllIfNoResults: Boolean) {
  facilitiesByAddress(
    brand: $brand
    address: $address
    fetchAllIfNoResults: $fetchAllIfNoResults
  ) {
    ...BffFacilityFields
  }
}
    ${BffFacilityFieldsFragmentDoc}
${BffFacilityAddressFragmentDoc}
${BffFacilityLocationFragmentDoc}
${BffWorkingHoursFragmentDoc}
${BffTimeSpanFragmentDoc}
${BffProviderFieldsFragmentDoc}
${BffNamedAttributeFragmentDoc}
${BffReviewsFragmentDoc}`;

export function useBffFacilitiesByAddressQuery(options: Omit<Urql.UseQueryArgs<BffFacilitiesByAddressQueryVariables>, 'query'>) {
  return Urql.useQuery<BffFacilitiesByAddressQuery, BffFacilitiesByAddressQueryVariables>({ query: BffFacilitiesByAddressDocument, ...options });
};
export const BffFacilitiesBySearchDocument = gql`
    query bffFacilitiesBySearch($brand: BffBrandType!, $address: String!, $fetchAllIfNoResults: Boolean) {
  facilitiesBySearch(
    brand: $brand
    address: $address
    fetchAllIfNoResults: $fetchAllIfNoResults
  ) {
    ...BffFacilityFields
  }
}
    ${BffFacilityFieldsFragmentDoc}
${BffFacilityAddressFragmentDoc}
${BffFacilityLocationFragmentDoc}
${BffWorkingHoursFragmentDoc}
${BffTimeSpanFragmentDoc}
${BffProviderFieldsFragmentDoc}
${BffNamedAttributeFragmentDoc}
${BffReviewsFragmentDoc}`;

export function useBffFacilitiesBySearchQuery(options: Omit<Urql.UseQueryArgs<BffFacilitiesBySearchQueryVariables>, 'query'>) {
  return Urql.useQuery<BffFacilitiesBySearchQuery, BffFacilitiesBySearchQueryVariables>({ query: BffFacilitiesBySearchDocument, ...options });
};
export const BffFacilitiesByStateDocument = gql`
    query bffFacilitiesByState($brand: BffBrandType!, $state: String!) {
  facilitiesByState(brand: $brand, state: $state) {
    ...BffFacilityFields
  }
}
    ${BffFacilityFieldsFragmentDoc}
${BffFacilityAddressFragmentDoc}
${BffFacilityLocationFragmentDoc}
${BffWorkingHoursFragmentDoc}
${BffTimeSpanFragmentDoc}
${BffProviderFieldsFragmentDoc}
${BffNamedAttributeFragmentDoc}
${BffReviewsFragmentDoc}`;

export function useBffFacilitiesByStateQuery(options: Omit<Urql.UseQueryArgs<BffFacilitiesByStateQueryVariables>, 'query'>) {
  return Urql.useQuery<BffFacilitiesByStateQuery, BffFacilitiesByStateQueryVariables>({ query: BffFacilitiesByStateDocument, ...options });
};
export const BffFacilitiesByStateAndCityDocument = gql`
    query bffFacilitiesByStateAndCity($brand: BffBrandType!, $state: String!, $city: String!) {
  facilitiesByStateAndCity(brand: $brand, state: $state, city: $city) {
    ...BffFacilityFields
  }
}
    ${BffFacilityFieldsFragmentDoc}
${BffFacilityAddressFragmentDoc}
${BffFacilityLocationFragmentDoc}
${BffWorkingHoursFragmentDoc}
${BffTimeSpanFragmentDoc}
${BffProviderFieldsFragmentDoc}
${BffNamedAttributeFragmentDoc}
${BffReviewsFragmentDoc}`;

export function useBffFacilitiesByStateAndCityQuery(options: Omit<Urql.UseQueryArgs<BffFacilitiesByStateAndCityQueryVariables>, 'query'>) {
  return Urql.useQuery<BffFacilitiesByStateAndCityQuery, BffFacilitiesByStateAndCityQueryVariables>({ query: BffFacilitiesByStateAndCityDocument, ...options });
};
export const BffFacilitiesByStateCityAndStreetDocument = gql`
    query bffFacilitiesByStateCityAndStreet($brand: BffBrandType!, $state: String!, $city: String!, $street: String!) {
  facilitiesByStateCityAndStreet(
    brand: $brand
    state: $state
    city: $city
    street: $street
  ) {
    ...BffFacilityFields
  }
}
    ${BffFacilityFieldsFragmentDoc}
${BffFacilityAddressFragmentDoc}
${BffFacilityLocationFragmentDoc}
${BffWorkingHoursFragmentDoc}
${BffTimeSpanFragmentDoc}
${BffProviderFieldsFragmentDoc}
${BffNamedAttributeFragmentDoc}
${BffReviewsFragmentDoc}`;

export function useBffFacilitiesByStateCityAndStreetQuery(options: Omit<Urql.UseQueryArgs<BffFacilitiesByStateCityAndStreetQueryVariables>, 'query'>) {
  return Urql.useQuery<BffFacilitiesByStateCityAndStreetQuery, BffFacilitiesByStateCityAndStreetQueryVariables>({ query: BffFacilitiesByStateCityAndStreetDocument, ...options });
};
export const BffFacilitiesByZipcodeDocument = gql`
    query bffFacilitiesByZipcode($brand: BffBrandType!, $zipCode: String!, $radiusMiles: Int, $maxItems: Int, $fetchAllIfNoResults: Boolean) {
  facilitiesByZipcode(
    brand: $brand
    zipCode: $zipCode
    radiusMiles: $radiusMiles
    maxItems: $maxItems
    fetchAllIfNoResults: $fetchAllIfNoResults
  ) {
    ...BffFacilityFields
  }
}
    ${BffFacilityFieldsFragmentDoc}
${BffFacilityAddressFragmentDoc}
${BffFacilityLocationFragmentDoc}
${BffWorkingHoursFragmentDoc}
${BffTimeSpanFragmentDoc}
${BffProviderFieldsFragmentDoc}
${BffNamedAttributeFragmentDoc}
${BffReviewsFragmentDoc}`;

export function useBffFacilitiesByZipcodeQuery(options: Omit<Urql.UseQueryArgs<BffFacilitiesByZipcodeQueryVariables>, 'query'>) {
  return Urql.useQuery<BffFacilitiesByZipcodeQuery, BffFacilitiesByZipcodeQueryVariables>({ query: BffFacilitiesByZipcodeDocument, ...options });
};
export const BffFacilityByIdDocument = gql`
    query bffFacilityById($brand: BffBrandType!, $id: String!) {
  facilityById(brand: $brand, id: $id) {
    ...BffFacilityFields
  }
}
    ${BffFacilityFieldsFragmentDoc}
${BffFacilityAddressFragmentDoc}
${BffFacilityLocationFragmentDoc}
${BffWorkingHoursFragmentDoc}
${BffTimeSpanFragmentDoc}
${BffProviderFieldsFragmentDoc}
${BffNamedAttributeFragmentDoc}
${BffReviewsFragmentDoc}`;

export function useBffFacilityByIdQuery(options: Omit<Urql.UseQueryArgs<BffFacilityByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<BffFacilityByIdQuery, BffFacilityByIdQueryVariables>({ query: BffFacilityByIdDocument, ...options });
};
export const BffFacilityCitiesDocument = gql`
    query bffFacilityCities($brand: BffBrandType!) {
  facilityCities(brand: $brand) {
    city
    state
    stateAbbreviation
    slugXml
    centers {
      id
      name
      address {
        address1
        zipCode
      }
    }
  }
}
    `;

export function useBffFacilityCitiesQuery(options: Omit<Urql.UseQueryArgs<BffFacilityCitiesQueryVariables>, 'query'>) {
  return Urql.useQuery<BffFacilityCitiesQuery, BffFacilityCitiesQueryVariables>({ query: BffFacilityCitiesDocument, ...options });
};
export const BffFacilityCitiesByStateDocument = gql`
    query bffFacilityCitiesByState($brand: BffBrandType!, $state: String!) {
  facilityCitiesByState(brand: $brand, state: $state) {
    city
    state
    stateAbbreviation
  }
}
    `;

export function useBffFacilityCitiesByStateQuery(options: Omit<Urql.UseQueryArgs<BffFacilityCitiesByStateQueryVariables>, 'query'>) {
  return Urql.useQuery<BffFacilityCitiesByStateQuery, BffFacilityCitiesByStateQueryVariables>({ query: BffFacilityCitiesByStateDocument, ...options });
};
export const FacilityCollectionDocument = gql`
    query FacilityCollection($brand: BffBrandType!, $skip: Int, $take: Int) {
  facilityCollection(brand: $brand, skip: $skip, take: $take) {
    items {
      code
      slugXml
    }
    total
    skip
    take
  }
}
    `;

export function useFacilityCollectionQuery(options: Omit<Urql.UseQueryArgs<FacilityCollectionQueryVariables>, 'query'>) {
  return Urql.useQuery<FacilityCollectionQuery, FacilityCollectionQueryVariables>({ query: FacilityCollectionDocument, ...options });
};
export const BffFacilityStatesDocument = gql`
    query bffFacilityStates($brand: BffBrandType!) {
  facilityStates(brand: $brand) {
    abbreviation
    name
    slugXml
  }
}
    `;

export function useBffFacilityStatesQuery(options: Omit<Urql.UseQueryArgs<BffFacilityStatesQueryVariables>, 'query'>) {
  return Urql.useQuery<BffFacilityStatesQuery, BffFacilityStatesQueryVariables>({ query: BffFacilityStatesDocument, ...options });
};
export const BffNearByFacilitiesByLocationDocument = gql`
    query bffNearByFacilitiesByLocation($brand: BffBrandType!, $latitude: Float!, $longitude: Float!, $fetchAllIfNoResults: Boolean, $radiusMiles: Int, $maxItems: Int) {
  facilityByLocation(
    brand: $brand
    latitude: $latitude
    longitude: $longitude
    fetchAllIfNoResults: $fetchAllIfNoResults
    radiusMiles: $radiusMiles
    maxItems: $maxItems
  ) {
    ...BffFacilityFields
  }
}
    ${BffFacilityFieldsFragmentDoc}
${BffFacilityAddressFragmentDoc}
${BffFacilityLocationFragmentDoc}
${BffWorkingHoursFragmentDoc}
${BffTimeSpanFragmentDoc}
${BffProviderFieldsFragmentDoc}
${BffNamedAttributeFragmentDoc}
${BffReviewsFragmentDoc}`;

export function useBffNearByFacilitiesByLocationQuery(options: Omit<Urql.UseQueryArgs<BffNearByFacilitiesByLocationQueryVariables>, 'query'>) {
  return Urql.useQuery<BffNearByFacilitiesByLocationQuery, BffNearByFacilitiesByLocationQueryVariables>({ query: BffNearByFacilitiesByLocationDocument, ...options });
};
export const BffProductsWithIdsDocument = gql`
    query bffProductsWithIds($brand: BffBrandType!, $idList: [String]!, $facilityCode: String!) {
  productsWithIds(brand: $brand, idList: $idList, facilityCode: $facilityCode) {
    brand
    brandfolderImageAssetUrl
    category
    subCategory
    description
    id
    name
    procedures {
      price
      procedureCode
      procedureDescription
    }
    linkText
    linkUrl
    totalPrice
  }
}
    `;

export function useBffProductsWithIdsQuery(options: Omit<Urql.UseQueryArgs<BffProductsWithIdsQueryVariables>, 'query'>) {
  return Urql.useQuery<BffProductsWithIdsQuery, BffProductsWithIdsQueryVariables>({ query: BffProductsWithIdsDocument, ...options });
};
export const BffReviewsDocument = gql`
    query bffReviews($brand: BffBrandType!, $facilityCode: String!) {
  reviews(brand: $brand, facilityCode: $facilityCode) {
    averageRating
    businessId
    ratings {
      rating
      reviewCount
    }
    reviewCount
    reviews {
      comments
      rating
      reviewId
      reviewTimestamp
      reviewer {
        firstName
        lastName
      }
      source
    }
  }
}
    `;

export function useBffReviewsQuery(options: Omit<Urql.UseQueryArgs<BffReviewsQueryVariables>, 'query'>) {
  return Urql.useQuery<BffReviewsQuery, BffReviewsQueryVariables>({ query: BffReviewsDocument, ...options });
};
export const BffReviewsSelectionDocument = gql`
    query bffReviewsSelection($brand: BffBrandType!, $facilityCode: String!, $min: Int, $max: Int, $take: Int) {
  reviewsSelection(
    brand: $brand
    facilityCode: $facilityCode
    min: $min
    max: $max
    take: $take
  ) {
    comments
    rating
    reviewId
    reviewTimestamp
    source
    tags
    title
    reviewer {
      firstName
      lastName
    }
  }
}
    `;

export function useBffReviewsSelectionQuery(options: Omit<Urql.UseQueryArgs<BffReviewsSelectionQueryVariables>, 'query'>) {
  return Urql.useQuery<BffReviewsSelectionQuery, BffReviewsSelectionQueryVariables>({ query: BffReviewsSelectionDocument, ...options });
};
export const FacilityByIdDocument = gql`
    query FacilityById($brand: BffBrandType!, $facilityByIdId: String!) {
  facilityById(brand: $brand, id: $facilityByIdId) {
    doctors {
      firstName
      lastName
      quote
    }
  }
}
    `;

export function useFacilityByIdQuery(options: Omit<Urql.UseQueryArgs<FacilityByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<FacilityByIdQuery, FacilityByIdQueryVariables>({ query: FacilityByIdDocument, ...options });
};
export const GetSelectedReviewsIdDocument = gql`
    query getSelectedReviewsId($code: String!, $brand: BffBrandType!, $min: Int, $max: Int, $take: Int) {
  reviewsSelection(
    brand: $brand
    facilityCode: $code
    min: $min
    max: $max
    take: $take
  ) {
    reviewId
  }
}
    `;

export function useGetSelectedReviewsIdQuery(options: Omit<Urql.UseQueryArgs<GetSelectedReviewsIdQueryVariables>, 'query'>) {
  return Urql.useQuery<GetSelectedReviewsIdQuery, GetSelectedReviewsIdQueryVariables>({ query: GetSelectedReviewsIdDocument, ...options });
};
export const ProviderPicByNpiDocument = gql`
    query providerPicByNpi($brand: BffBrandType!, $npi: String!) {
  providerPicByNpi(brand: $brand, npi: $npi) {
    url
  }
}
    `;

export function useProviderPicByNpiQuery(options: Omit<Urql.UseQueryArgs<ProviderPicByNpiQueryVariables>, 'query'>) {
  return Urql.useQuery<ProviderPicByNpiQuery, ProviderPicByNpiQueryVariables>({ query: ProviderPicByNpiDocument, ...options });
};
export const ProvidersByIdListDocument = gql`
    query providersByIdList($brand: BffBrandType!, $idList: [String]!) {
  providersByIdList(brand: $brand, idList: $idList) {
    ...BffProviderFields
  }
}
    ${BffProviderFieldsFragmentDoc}`;

export function useProvidersByIdListQuery(options: Omit<Urql.UseQueryArgs<ProvidersByIdListQueryVariables>, 'query'>) {
  return Urql.useQuery<ProvidersByIdListQuery, ProvidersByIdListQueryVariables>({ query: ProvidersByIdListDocument, ...options });
};
export const ReviewSummaryByProviderDocument = gql`
    query reviewSummaryByProvider($brand: BffBrandType!, $npi: String!) {
  reviewSummaryByProvider(brand: $brand, npi: $npi) {
    providerId
    averageRating
    reviewCount
    ratings {
      rating
      reviewCount
    }
  }
}
    `;

export function useReviewSummaryByProviderQuery(options: Omit<Urql.UseQueryArgs<ReviewSummaryByProviderQueryVariables>, 'query'>) {
  return Urql.useQuery<ReviewSummaryByProviderQuery, ReviewSummaryByProviderQueryVariables>({ query: ReviewSummaryByProviderDocument, ...options });
};
export const ReviewsByProviderDocument = gql`
    query reviewsByProvider($brand: BffBrandType!, $npi: String!) {
  reviewsByProvider(brand: $brand, npi: $npi) {
    comments
    rating
    reviewId
    reviewTimestamp
    reviewer {
      firstName
      lastName
    }
    source
  }
}
    `;

export function useReviewsByProviderQuery(options: Omit<Urql.UseQueryArgs<ReviewsByProviderQueryVariables>, 'query'>) {
  return Urql.useQuery<ReviewsByProviderQuery, ReviewsByProviderQueryVariables>({ query: ReviewsByProviderDocument, ...options });
};